import { createStore } from 'vuex';
import axios from '../axios';

const storedTheme = localStorage.getItem('theme');
const initialTheme = storedTheme === 'dark' ? 'dark' : 'light';
if (storedTheme !== initialTheme) {
    localStorage.setItem('theme', initialTheme);
}

export default createStore({
    state: {
        user: null,
        data: [],
        url: axios.defaults.baseURL,
        currentLang: localStorage.getItem('language') || 'fa',
        theme: initialTheme
    },
    mutations: {
        setUser(state, user) {
            state.user = user;
        },
        setData(state, data) {
            state.data = data;
        },
        setLanguage(state, lang) {
            state.currentLang = lang;
            localStorage.setItem('language', lang);
        },
        setTheme(state, theme) {
            state.theme = theme;
            localStorage.setItem('theme', theme);
        }
    },
    actions: {
        fetchUser({ commit }) {
            const user = localStorage.getItem('user');
            if (user) {
                commit('setUser', JSON.parse(user));
            }
        },

        async login({ commit }, { email, password }) {
            try {
                const hashedPassword = btoa(password);
                const response = await axios.post('/login-api', {
                    email,
                    password: password
                });

                if (response.data !== "wrong") {
                    commit('setUser', response.data[0]);
                    localStorage.setItem('user', JSON.stringify(response.data[0]));
                    localStorage.setItem('level', JSON.stringify(response.data[1]));
                    localStorage.setItem('email', email);
                    localStorage.setItem('password', hashedPassword);
                }
                return response.data;
            } catch (error) {
                console.error('Error logging in:', error);
                throw error;
            }
        },

        async register({ commit }, { nameFamily, username,email, mobile,moaref, password,password2,code,type}) {
            try {
                const hashedPassword = btoa(password);
                const response = await axios.post('/register-api', {
                    nameFamily,
                    username,
                    email,
                    mobile,
                    moaref,
                    password: password,
                    password2,
                    code,
                    type,
                });

                if (response.data[0] === "success") {
                    commit('setUser', response.data);
                    localStorage.setItem('user', JSON.stringify(response.data[1]));
                    localStorage.setItem('email', email);
                    localStorage.setItem('password', hashedPassword);
                }
                return response.data;
            } catch (error) {
                console.error('Error logging in:', error);
                throw error;
            }
        },

        changeLanguage({ commit }, lang) {
            commit('setLanguage', lang);
        },

        changeTheme({ commit }, theme) {
            commit('setTheme', theme);
        },

    },
    modules: {}
});